import React from 'react';
import { CheckCircle } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 dark:bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white dark:bg-slate-900 rounded-3xl border border-gray-200 dark:border-white/10 max-w-md max-w-7xl shadow-2xl">
        <div className="p-8 text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl mx-auto mb-6 flex items-center justify-center">
            <CheckCircle className="w-8 h-8 text-white" aria-hidden="true" />
          </div>

          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{title}</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-8 leading-relaxed">{message}</p>

          <button
            onClick={onClose}
            className="px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};